import React from 'react';
import { Link } from 'react-router-dom';
import './CSS/OrderSuccess.css'; // You can reuse the same CSS

const OrderCancel = () => {
    return (
        <div className="order-success-container">
            <div className="order-success-card">
                <h2>Payment Canceled</h2>
                <p>Your payment process was canceled. Your cart has been saved if you'd like to try again.</p>
                <Link to="/cart" className="continue-shopping-btn">Return to Cart</Link>
            </div>
        </div>
    );
};

export default OrderCancel;